import { createPaginator } from "@smithy/core";
import { ChimeSDKMessagingClient } from "../ChimeSDKMessagingClient";
import { ListChannelsAssociatedWithChannelFlowCommand, } from "../commands/ListChannelsAssociatedWithChannelFlowCommand";
export const paginateListChannelsAssociatedWithChannelFlow = createPaginator(ChimeSDKMessagingClient, ListChannelsAssociatedWithChannelFlowCommand, "NextToken", "NextToken", "MaxResults");
